/**
 * MultipleCheckbox
 * 
 * @Author: Focci
 * @Date: 2023-08-08 11:02:01
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-08 11:02:01
 */

import PropTypes from 'prop-types'
import { Checkbox } from '@comp/material'
import { useState, useCallback, useEffect } from 'react'
import clsx from 'clsx'

export default function MultipleCheckbox({
  options = [],
  value = [],
  itemClassName = '',
  itemRender = (item) => item.label,
  onChange = () => {}
}) {
  const [checked, setChecked] = useState([])

  const handleChange = useCallback((item) => {
    const index = checked.indexOf(item.value)
    let prev = [...checked]
    if(index > -1) {
      prev.splice(index, 1)
    } else {
      prev = [...prev, item.value]
    }

    onChange(prev)
    setChecked(prev)
  }, [checked, onChange])

  useEffect(() => { setChecked(value) }, [value])

  return (
    options.map((item) => (
      <label
        key={item.value} 
        className={clsx([
          'flex items-center gap-x-1 cursor-pointer py-1',
          itemClassName
        ])}
      >
        <Checkbox
          checked={checked.indexOf(item.value) > -1}
          onChange={() => handleChange(item)}
        />
        <div className="text-f.7 flex-auto">
          {itemRender(item)}
        </div>
      </label>
    ))
  )
}

MultipleCheckbox.propTypes = {
  options: PropTypes.array,
  value: PropTypes.array,
  itemClassName: PropTypes.string,
  itemRender: PropTypes.func,
  onChange: PropTypes.func,
}
